export const ListQueryKey = 'fullExchangeRecords';
export const DetailQueryKey = 'fullExchangeRecord';

export const Urls = {
  selectUrl: '/fullExchangeRecord/list',
  updateUrl: '/fullExchangeRecord/update',
  deleteUrl: '/fullExchangeRecord/delete',
  createUrl: '/fullExchangeRecord/create',
  detailUrl: '/fullExchangeRecord/detail',
};
